/**
 * Community impact highlight — loans shared interest-free with the community.
 */

import { useTranslation } from 'react-i18next'
import { Card } from '../../components/ui'
import { formatINRLakh } from '../../lib/money'
import type { PublicFundImpact } from './useSavingsPlans'

export function hasFundImpact(fundImpact?: PublicFundImpact): fundImpact is PublicFundImpact {
  return (fundImpact?.totalDisbursedPaise ?? 0) > 0
}

export function FundImpactCard({
  fundImpact,
  className = '',
}: {
  fundImpact: PublicFundImpact
  className?: string
}) {
  const { t } = useTranslation()
  if (!hasFundImpact(fundImpact)) return null

  return (
    <Card
      className={`landing-card relative overflow-hidden border-brand-200 bg-linear-to-br from-brand-50 via-white to-gold-50 ${className}`}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-8 -right-8 size-28 rounded-full bg-brand-200/40 blur-2xl"
      />
      <p className="relative text-xs font-semibold tracking-wide text-brand-700 uppercase">
        {t('landing.fundImpactLabel')}
      </p>
      <p className="relative mt-1 text-2xl font-bold tracking-tight text-brand-900 min-[400px]:text-3xl">
        {formatINRLakh(fundImpact.totalDisbursedPaise)}
      </p>
      <p className="relative mt-2 text-sm leading-relaxed text-stone-700">
        {t('landing.fundImpactBody', { count: fundImpact.loanCount })}
      </p>
    </Card>
  )
}
